var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import pubsub from "@viewlift/pubsub";
import { SEARCH_EVENTS, SEARCH_KEYS } from "../../../types/StandaloneSearchTypes";
import { useStandaloneSearchHelper } from "../../StandaloneSearch";
import { useLocation } from "react-router-dom";
import { SliderCore } from "../../../components/sliderCore";
import { downloadIcon } from "../../../../images/icon";
import "./index.scss";
export var SearchTrayModule = function (props) {
    var pathname = useLocation().pathname;
    var _a = __read(useState(props.contentData), 2), resultData = _a[0], setResultData = _a[1];
    var manageTrayVisibility = useStandaloneSearchHelper().manageTrayVisibility;
    var _b = __read(useState(undefined), 2), modData = _b[0], setModData = _b[1];
    var _c = __read(useState([]), 2), groupedData = _c[0], setGroupedData = _c[1];
    var manageTrayData = function () {
        var _processData = function (data) {
            var _a;
            if (data) {
                var _data = JSON.parse(data);
                // const _filtered = _data.search.records?.filter((item) =>
                // 	props.moduleData?.title?.toLowerCase().includes(item?.gist.contentType.toLowerCase()),
                // );
                // return setResultData({ contentData: _filtered });
                return setResultData({ contentData: (_a = _data === null || _data === void 0 ? void 0 : _data.search) === null || _a === void 0 ? void 0 : _a.records });
            }
        };
        pubsub.subscribe(SEARCH_EVENTS.REFRESH, _processData);
        pubsub.subscribe(SEARCH_KEYS.SEARCH_DATA, _processData);
    };
    var transformData = useCallback(function () {
        if (!resultData)
            return {};
        return __assign(__assign({}, props.moduleData), { contentData: resultData ? resultData.contentData : props.moduleData.contentData });
    }, [resultData]);
    useEffect(function () {
        if (pathname.includes("/search"))
            require("./searchTray.scss");
    }, [pathname]);
    useEffect(function () {
        manageTrayData();
        return function () { };
    }, [manageTrayData]);
    useEffect(function () {
        pubsub.subscribe(SEARCH_EVENTS.DELETE, function () {
            manageTrayVisibility("vl_search_tray_row", "block");
            return setResultData(undefined);
        });
    }, []);
    var getGroupedData = function () {
        var _a, _b;
        var data = resultData ? transformData() : props.moduleData;
        var groupData = ((_a = data === null || data === void 0 ? void 0 : data.contentData) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = data === null || data === void 0 ? void 0 : data.contentData) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, item) {
            var _a, _b;
            var key = (item === null || item === void 0 ? void 0 : item.mediaType) === "EPISODIC" ? item === null || item === void 0 ? void 0 : item.mediaType : item.gist.contentType;
            if (!acc[key]) {
                acc[key] = [];
            }
            if (acc[key]) {
                if (!acc[key]['contentData']) {
                    acc[key]['contentData'] = [];
                }
                acc[key]['contentData'].push(item);
            }
            var keyFirstLetterCapital = capitalizeFirstLetter(key === null || key === void 0 ? void 0 : key.toLowerCase());
            var title = ((_b = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.metadataMap) === null || _b === void 0 ? void 0 : _b["".concat(key === null || key === void 0 ? void 0 : key.toLowerCase(), "Title")]) || null;
            acc[key] = __assign(__assign({}, data), { title: "".concat(title || keyFirstLetterCapital), contentData: acc[key]['contentData'] });
            return acc;
        }, []));
        setGroupedData(groupData);
    };
    var capitalizeFirstLetter = function (string) { return string === null || string === void 0 ? void 0 : string.replace(/./, function (c) { return c.toUpperCase(); }); };
    useEffect(function () {
        getGroupedData();
        return function () { };
    }, []);
    // if (props.moduleData?.contentData?.length === 0) return null;
    // if (resultData?.contentData?.length === 0) return null;
    if (Object.values(groupedData).length < 1)
        return null;
    return (React.createElement("span", { id: "vl_search_tray_wrapper" }, Object.values(groupedData).length > 0 && Object.values(groupedData).map(function (item) {
        return (React.createElement(SliderCore, { data: { layout: item.layout, contentData: item === null || item === void 0 ? void 0 : item.contentData, title: item === null || item === void 0 ? void 0 : item.title }, icon: downloadIcon }));
    })));
};
